import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_knowledge/policies")({
  beforeLoad: ({ context }) => guardRoute(context.me, "policies"),
  component: Outlet,
});
